class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('input', this.onVariantChange);
		const priceSection = document.getElementById(`price-${this.dataset.section}`);
		priceSection.classList.remove('loading-price');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateQuantityMax();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

	updateQuantityMax() {
		window.dispatchEvent(new CustomEvent('update-product-quantity'));
	}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const id = `primary-image`
    const destination = document.getElementById(id)
    const loader = document.querySelector('#primary-image > #image-loader')

    loader.classList.replace('hidden', 'flex')
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
    })
    .then(document.getElementById('media-section').scrollIntoView())

    // const newMedia = document.querySelector(
    //   `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    // );

    // if (!newMedia) return;
    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // const parent = newMedia.parentElement;
    // if (parent.firstChild == newMedia) return;
    // modalContent.prepend(newMediaModal);
    // parent.prepend(newMedia);
    // this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    // if(this.stickyHeader) {
    //   this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    // }
    // window.setTimeout(() => {
    //   parent.scrollLeft = 0;
    //   parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    // });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
		this.priceLoading(`price-${this.dataset.section}`);
		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

				const destinationMax = document.getElementById("quantity-selector");
				const sourceMax = html.getElementById("quantity-selector");

        const destinationDesc = document.getElementById("product-description");
        const sourceDesc = html.getElementById("product-description");

        const destinationAvailability = document.getElementById("store-availability");
        const sourceAvailability = html.getElementById("store-availability");

				this.hidePriceLoading(destination);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourceDesc && destinationDesc) destinationDesc.innerHTML = sourceDesc.innerHTML;
        if (sourceAvailability && destinationAvailability) destinationAvailability.innerHTML = sourceAvailability.innerHTML;
				if (destinationMax && sourceMax) {
					destinationMax.outerHTML = sourceMax.outerHTML;
					window.dispatchEvent(new CustomEvent('update-product-quantity'));
				}

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, 'Sold Out');
      });
  }

	priceLoading(id) {
		let priceDestination = document.querySelector(`#${id}>span`);
		priceDestination.innerHTML = '';
		priceDestination.classList.add('loading-price');
		setTimeout(() => {
			priceDestination.classList.remove('loading-price');
		}, 5000);
	}
	hidePriceLoading(element) {
		element.classList.remove('loading-price');
	}

  toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = 'Add to Cart';
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const availability = document.getElementById('store-availability');
    if (availability) availability.innerHTML = '';
    if (!addButton) return;
    addButtonText.textContent = 'Unavailable';
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('#variants-json').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
		const colorButtonFieldset = document.querySelectorAll(`[data-option-name="Color"]`);
		const variantsAndImagesTag = document.querySelector('#variants-and-images');
		let variantsAndImages;
		if (variantsAndImagesTag) {
			variantsAndImages = JSON.parse(document.querySelector('#variants-and-images').textContent);
		}
		if (colorButtonFieldset.length > 0) {
			let variants = this.getVariantData();
			variants.map((variant) => {
				let variantAndImage = variantsAndImages.find((variantOption) => variantOption.title==variant.option1);
				let label = document.querySelector(`label[title="${variant.option1}"]`);
        if (variantAndImage.image !== "null") {
					label.style.backgroundImage = `url(${variantAndImage.image})`;
				} else {
					label.style.backgroundColor = `#d6d3d1`;
				}
			})
		}
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
